import Section, { SubSection } from './Section'
import styled, { useTheme } from 'styled-components'
import i18n, { t, tStr } from '@utils/lang'

const ImageDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  gap: 20px;
  img {
    border-radius: 0;
  }
`

const DownloadApp = () => {
  const theme = useTheme()
  const img = theme.color.mode === 'dark' ? 'runnerApp_dark.png' : 'runnerApp.png'
  return (
    <Section title={tStr('downloadTitle_s')} tagLine={tStr('downloadTagLine_s')}>
      <SubSection title={tStr('downloadSubTitle_s')} img={<img src={`/images/${i18n.locale}/${img}`} alt="" />}>
        {t('downloadBody_s')}
        <ImageDiv>
          <a href="https://apps.apple.com/us/app/favor-runner-deliver-earn/id1295308505">
            <img src={`/images/${i18n.locale}/AppleStore.png`} alt={tStr('appleStoreAlt_s')} />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.neighbfav.neighborfavor.runner">
            <img src={`/images/${i18n.locale}/GooglePlay.png`} alt={tStr('googlePlayAlt_s')} />
          </a>
        </ImageDiv>
      </SubSection>
    </Section>
  )
}

export default DownloadApp
